/* jshint ignore:start */
import Component from 'metal-component';
import Soy from 'metal-soy';

var templates;
goog.loadModule(function(exports) {
var soy = goog.require('soy');
var soydata = goog.require('soydata');
// This file was automatically generated from ClayDropdownBase.soy.
// Please don't edit this file by hand.

/**
 * @fileoverview Templates in namespace ClayDropdownBase.
 * @hassoydeltemplate {ClayDropdownBase.Content.idom}
 * @hassoydelcall {ClayDropdownBase.Content.idom}
 * @public
 */

goog.module('ClayDropdownBase.incrementaldom');

goog.require('goog.soy.data.SanitizedContent');
var incrementalDom = goog.require('incrementaldom');
goog.require('soy');
goog.require('soy.asserts');
var soyIdom = goog.require('soy.idom');

var $templateAlias1 = Soy.getTemplate('ClayButton.incrementaldom', 'render');

var $templateAlias3 = Soy.getTemplate('ClayDropdownItem.incrementaldom', 'render');

var $templateAlias4 = Soy.getTemplate('ClayLink.incrementaldom', 'render');

var $templateAlias2 = Soy.getTemplate('ClayPortal.incrementaldom', 'render');


/**
 * @param {$render.Params} opt_data
 * @param {Object<string, *>=} opt_ijData
 * @param {Object<string, *>=} opt_ijData_deprecated
 * @return {void}
 * @suppress {checkTypes|uselessCode}
 */
var $render = function(opt_data, opt_ijData, opt_ijData_deprecated) {
  opt_ijData = opt_ijData_deprecated || opt_ijData;
  /** @type {!Array<?>} */
  var items = soy.asserts.assertType(goog.isArray(opt_data.items), 'items', opt_data.items, '!Array<?>');
  /** @type {!goog.soy.data.SanitizedContent|function()|string} */
  var label = soy.asserts.assertType(goog.isFunction(opt_data.label) || (goog.isString(opt_data.label) || opt_data.label instanceof goog.soy.data.SanitizedContent), 'label', opt_data.label, '!goog.soy.data.SanitizedContent|function()|string');
  /** @type {*|null|undefined} */
  var _handleButtonClick = opt_data._handleButtonClick;
  /** @type {*|null|undefined} */
  var _handleItemClick = opt_data._handleItemClick;
  /** @type {*|null|undefined} */
  var _handleSearch = opt_data._handleSearch;
  /** @type {?} */
  var button = opt_data.button;
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var caption = soy.asserts.assertType(opt_data.caption == null || (goog.isString(opt_data.caption) || opt_data.caption instanceof goog.soy.data.SanitizedContent), 'caption', opt_data.caption, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var contentRenderer = soy.asserts.assertType(opt_data.contentRenderer == null || (goog.isString(opt_data.contentRenderer) || opt_data.contentRenderer instanceof goog.soy.data.SanitizedContent), 'contentRenderer', opt_data.contentRenderer, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {boolean|null|undefined} */
  var disabled = soy.asserts.assertType(opt_data.disabled == null || (goog.isBoolean(opt_data.disabled) || opt_data.disabled === 1 || opt_data.disabled === 0), 'disabled', opt_data.disabled, 'boolean|null|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var elementClasses = soy.asserts.assertType(opt_data.elementClasses == null || (goog.isString(opt_data.elementClasses) || opt_data.elementClasses instanceof goog.soy.data.SanitizedContent), 'elementClasses', opt_data.elementClasses, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {boolean|null|undefined} */
  var expanded = soy.asserts.assertType(opt_data.expanded == null || (goog.isBoolean(opt_data.expanded) || opt_data.expanded === 1 || opt_data.expanded === 0), 'expanded', opt_data.expanded, 'boolean|null|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var helpText = soy.asserts.assertType(opt_data.helpText == null || (goog.isString(opt_data.helpText) || opt_data.helpText instanceof goog.soy.data.SanitizedContent), 'helpText', opt_data.helpText, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var id = soy.asserts.assertType(opt_data.id == null || (goog.isString(opt_data.id) || opt_data.id instanceof goog.soy.data.SanitizedContent), 'id', opt_data.id, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var itemsIconAlignment = soy.asserts.assertType(opt_data.itemsIconAlignment == null || (goog.isString(opt_data.itemsIconAlignment) || opt_data.itemsIconAlignment instanceof goog.soy.data.SanitizedContent), 'itemsIconAlignment', opt_data.itemsIconAlignment, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var portalElementId = soy.asserts.assertType(opt_data.portalElementId == null || (goog.isString(opt_data.portalElementId) || opt_data.portalElementId instanceof goog.soy.data.SanitizedContent), 'portalElementId', opt_data.portalElementId, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {boolean|null|undefined} */
  var searchable = soy.asserts.assertType(opt_data.searchable == null || (goog.isBoolean(opt_data.searchable) || opt_data.searchable === 1 || opt_data.searchable === 0), 'searchable', opt_data.searchable, 'boolean|null|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var spritemap = soy.asserts.assertType(opt_data.spritemap == null || (goog.isString(opt_data.spritemap) || opt_data.spritemap instanceof goog.soy.data.SanitizedContent), 'spritemap', opt_data.spritemap, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var style = soy.asserts.assertType(opt_data.style == null || (goog.isString(opt_data.style) || opt_data.style instanceof goog.soy.data.SanitizedContent), 'style', opt_data.style, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var triggerClasses = soy.asserts.assertType(opt_data.triggerClasses == null || (goog.isString(opt_data.triggerClasses) || opt_data.triggerClasses instanceof goog.soy.data.SanitizedContent), 'triggerClasses', opt_data.triggerClasses, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var triggerSize = soy.asserts.assertType(opt_data.triggerSize == null || (goog.isString(opt_data.triggerSize) || opt_data.triggerSize instanceof goog.soy.data.SanitizedContent), 'triggerSize', opt_data.triggerSize, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var triggerTitle = soy.asserts.assertType(opt_data.triggerTitle == null || (goog.isString(opt_data.triggerTitle) || opt_data.triggerTitle instanceof goog.soy.data.SanitizedContent), 'triggerTitle', opt_data.triggerTitle, '!goog.soy.data.SanitizedContent|null|string|undefined');
  var attributes__soy280 = function() {
    incrementalDom.attr('class', 'dropdown' + (elementClasses ? ' ' + elementClasses : '') + (expanded ? ' show' : ''));
    if (id) {
      incrementalDom.attr('id', id);
    }
  };
  incrementalDom.elementOpenStart('div');
      attributes__soy280();
  incrementalDom.elementOpenEnd();
  $trigger({classes: triggerClasses, disabled: disabled, expanded: expanded, label: label, size: triggerSize, style: style, title: triggerTitle}, opt_ijData);
  $sections({_handleButtonClick: _handleButtonClick, _handleItemClick: _handleItemClick, _handleSearch: _handleSearch, button: button, caption: caption, contentRenderer: contentRenderer != null ? contentRenderer : '', expanded: expanded, helpText: helpText, items: items, itemsIconAlignment: itemsIconAlignment, portalElementId: portalElementId, searchable: searchable, spritemap: spritemap}, opt_ijData);
  incrementalDom.elementClose('div');
};
exports.render = $render;
/**
 * @typedef {{
 *  items: !Array<?>,
 *  label: (!goog.soy.data.SanitizedContent|function()|string),
 *  _handleButtonClick: (*|null|undefined),
 *  _handleItemClick: (*|null|undefined),
 *  _handleSearch: (*|null|undefined),
 *  button: (?|undefined),
 *  caption: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  contentRenderer: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  disabled: (boolean|null|undefined),
 *  elementClasses: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  expanded: (boolean|null|undefined),
 *  helpText: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  id: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  itemsIconAlignment: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  portalElementId: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  searchable: (boolean|null|undefined),
 *  spritemap: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  style: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  triggerClasses: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  triggerSize: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  triggerTitle: (!goog.soy.data.SanitizedContent|null|string|undefined),
 * }}
 */
$render.Params;
if (goog.DEBUG) {
  $render.soyTemplateName = 'ClayDropdownBase.render';
}


/**
 * @param {$items.Params} opt_data
 * @param {Object<string, *>=} opt_ijData
 * @param {Object<string, *>=} opt_ijData_deprecated
 * @return {void}
 * @suppress {checkTypes|uselessCode}
 */
var $items = function(opt_data, opt_ijData, opt_ijData_deprecated) {
  opt_ijData = opt_ijData_deprecated || opt_ijData;
  /** @type {!Array<?>} */
  var items = soy.asserts.assertType(goog.isArray(opt_data.items), 'items', opt_data.items, '!Array<?>');
  /** @type {*|null|undefined} */
  var _handleItemClick = opt_data._handleItemClick;
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var contentRenderer = soy.asserts.assertType(opt_data.contentRenderer == null || (goog.isString(opt_data.contentRenderer) || opt_data.contentRenderer instanceof goog.soy.data.SanitizedContent), 'contentRenderer', opt_data.contentRenderer, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var itemsIconAlignment = soy.asserts.assertType(opt_data.itemsIconAlignment == null || (goog.isString(opt_data.itemsIconAlignment) || opt_data.itemsIconAlignment instanceof goog.soy.data.SanitizedContent), 'itemsIconAlignment', opt_data.itemsIconAlignment, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {null|number|undefined} */
  var maxItems = soy.asserts.assertType(opt_data.maxItems == null || goog.isNumber(opt_data.maxItems), 'maxItems', opt_data.maxItems, 'null|number|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var spritemap = soy.asserts.assertType(opt_data.spritemap == null || (goog.isString(opt_data.spritemap) || opt_data.spritemap instanceof goog.soy.data.SanitizedContent), 'spritemap', opt_data.spritemap, '!goog.soy.data.SanitizedContent|null|string|undefined');
  var index316_RangeEnd = maxItems && maxItems < (items.length) ? maxItems : (items.length);
  var index316ListLen = Math.max(0, Math.ceil((index316_RangeEnd - 0) / 1));
  for (var index316Index = 0; index316Index < index316ListLen; index316Index++) {
    var index316Data = 0 + index316Index * 1;
    var item__soy319 = items[index316Data];
    var variant__soy334 = '';
    var $tmp;
    if ((contentRenderer != null) && contentRenderer != '') {
      $tmp = contentRenderer;
    } else if (item__soy319.type) {
      $tmp = item__soy319.type;
    } else {
      $tmp = 'item';
    }
    variant__soy334 += $tmp;
    $templateAlias3({active: item__soy319.active, checked: item__soy319.checked, contentRenderer: variant__soy334, data: item__soy319.data, disabled: item__soy319.disabled, events: {itemClicked: _handleItemClick}, href: item__soy319.href, icon: item__soy319.icon, inputName: item__soy319.inputName, inputValue: item__soy319.inputValue, items: item__soy319.items, itemsIconAlignment: itemsIconAlignment, label: item__soy319.label ? '' + item__soy319.label : '', maxItems: item__soy319.maxItems, separator: item__soy319.separator, spritemap: spritemap, title: item__soy319.title}, opt_ijData);
    if (item__soy319.separator) {
      $templateAlias3({contentRenderer: 'separator'}, opt_ijData);
    }
  }
};
exports.items = $items;
/**
 * @typedef {{
 *  items: !Array<?>,
 *  _handleItemClick: (*|null|undefined),
 *  contentRenderer: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  itemsIconAlignment: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  maxItems: (null|number|undefined),
 *  spritemap: (!goog.soy.data.SanitizedContent|null|string|undefined),
 * }}
 */
$items.Params;
if (goog.DEBUG) {
  $items.soyTemplateName = 'ClayDropdownBase.items';
}


/**
 * @param {$search.Params} opt_data
 * @param {Object<string, *>=} opt_ijData
 * @param {Object<string, *>=} opt_ijData_deprecated
 * @return {void}
 * @suppress {checkTypes|uselessCode}
 */
var $search = function(opt_data, opt_ijData, opt_ijData_deprecated) {
  opt_ijData = opt_ijData_deprecated || opt_ijData;
  /** @type {!goog.soy.data.SanitizedContent|string} */
  var spritemap = soy.asserts.assertType(goog.isString(opt_data.spritemap) || opt_data.spritemap instanceof goog.soy.data.SanitizedContent, 'spritemap', opt_data.spritemap, '!goog.soy.data.SanitizedContent|string');
  /** @type {*|null|undefined} */
  var _handleSearch = opt_data._handleSearch;
  incrementalDom.elementOpen('form');
  incrementalDom.elementOpenStart('div');
      incrementalDom.attr('class', 'dropdown-section');
  incrementalDom.elementOpenEnd();
  incrementalDom.elementOpenStart('div');
      incrementalDom.attr('class', 'input-group input-group-sm');
  incrementalDom.elementOpenEnd();
  incrementalDom.elementOpenStart('div');
      incrementalDom.attr('class', 'input-group-item');
  incrementalDom.elementOpenEnd();
  incrementalDom.elementOpenStart('input');
      incrementalDom.attr('aria-label', 'Search for...');
      incrementalDom.attr('class', 'form-control input-group-inset input-group-inset-after');
      incrementalDom.attr('data-oninput', _handleSearch);
      incrementalDom.attr('placeholder', 'Search for...');
      incrementalDom.attr('type', 'text');
      incrementalDom.attr('ref', 'searchInput');
  incrementalDom.elementOpenEnd();
  incrementalDom.elementClose('input');
  incrementalDom.elementOpenStart('span');
      incrementalDom.attr('class', 'input-group-inset-item input-group-inset-item-after');
  incrementalDom.elementOpenEnd();
  $templateAlias1({icon: 'search', spritemap: spritemap, style: 'link'}, opt_ijData);
  incrementalDom.elementClose('span');
  incrementalDom.elementClose('div');
  incrementalDom.elementClose('div');
  incrementalDom.elementClose('div');
  incrementalDom.elementClose('form');
};
exports.search = $search;
/**
 * @typedef {{
 *  spritemap: (!goog.soy.data.SanitizedContent|string),
 *  _handleSearch: (*|null|undefined),
 * }}
 */
$search.Params;
if (goog.DEBUG) {
  $search.soyTemplateName = 'ClayDropdownBase.search';
}


/**
 * @param {$sections.Params} opt_data
 * @param {Object<string, *>=} opt_ijData
 * @param {Object<string, *>=} opt_ijData_deprecated
 * @return {void}
 * @suppress {checkTypes|uselessCode}
 */
var $sections = function(opt_data, opt_ijData, opt_ijData_deprecated) {
  opt_ijData = opt_ijData_deprecated || opt_ijData;
  /** @type {!Array<?>} */
  var items = soy.asserts.assertType(goog.isArray(opt_data.items), 'items', opt_data.items, '!Array<?>');
  /** @type {*|null|undefined} */
  var _handleButtonClick = opt_data._handleButtonClick;
  /** @type {*|null|undefined} */
  var _handleItemClick = opt_data._handleItemClick;
  /** @type {*|null|undefined} */
  var _handleSearch = opt_data._handleSearch;
  /** @type {?} */
  var button = opt_data.button;
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var caption = soy.asserts.assertType(opt_data.caption == null || (goog.isString(opt_data.caption) || opt_data.caption instanceof goog.soy.data.SanitizedContent), 'caption', opt_data.caption, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var contentRenderer = soy.asserts.assertType(opt_data.contentRenderer == null || (goog.isString(opt_data.contentRenderer) || opt_data.contentRenderer instanceof goog.soy.data.SanitizedContent), 'contentRenderer', opt_data.contentRenderer, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {boolean|null|undefined} */
  var expanded = soy.asserts.assertType(opt_data.expanded == null || (goog.isBoolean(opt_data.expanded) || opt_data.expanded === 1 || opt_data.expanded === 0), 'expanded', opt_data.expanded, 'boolean|null|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var helpText = soy.asserts.assertType(opt_data.helpText == null || (goog.isString(opt_data.helpText) || opt_data.helpText instanceof goog.soy.data.SanitizedContent), 'helpText', opt_data.helpText, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var itemsIconAlignment = soy.asserts.assertType(opt_data.itemsIconAlignment == null || (goog.isString(opt_data.itemsIconAlignment) || opt_data.itemsIconAlignment instanceof goog.soy.data.SanitizedContent), 'itemsIconAlignment', opt_data.itemsIconAlignment, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var portalElementId = soy.asserts.assertType(opt_data.portalElementId == null || (goog.isString(opt_data.portalElementId) || opt_data.portalElementId instanceof goog.soy.data.SanitizedContent), 'portalElementId', opt_data.portalElementId, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {boolean|null|undefined} */
  var searchable = soy.asserts.assertType(opt_data.searchable == null || (goog.isBoolean(opt_data.searchable) || opt_data.searchable === 1 || opt_data.searchable === 0), 'searchable', opt_data.searchable, 'boolean|null|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var spritemap = soy.asserts.assertType(opt_data.spritemap == null || (goog.isString(opt_data.spritemap) || opt_data.spritemap instanceof goog.soy.data.SanitizedContent), 'spritemap', opt_data.spritemap, '!goog.soy.data.SanitizedContent|null|string|undefined');
  var dropdownMenu__soy475 = function() {
    var listAttributes__soy402 = function() {
      var $tmp;
      if (itemsIconAlignment == 'left') {
        $tmp = ' dropdown-menu-indicator-start';
      } else if (itemsIconAlignment == 'right') {
        $tmp = ' dropdown-menu-indicator-end';
      } else {
        $tmp = '';
      }
      incrementalDom.attr('class', 'dropdown-menu' + $tmp + (expanded ? ' show' : ''));
      incrementalDom.attr('ref', 'menu');
    };
    incrementalDom.elementOpenStart('div');
        listAttributes__soy402();
    incrementalDom.elementOpenEnd();
    if (helpText) {
      incrementalDom.elementOpenStart('div');
          incrementalDom.attr('class', 'alert alert-fluid alert-info');
          incrementalDom.attr('role', 'alert');
      incrementalDom.elementOpenEnd();
      soyIdom.print(helpText);
      incrementalDom.elementClose('div');
    }
    if (searchable && spritemap) {
      $search({_handleSearch: _handleSearch, spritemap: spritemap}, opt_ijData);
    }
    var listItemsContent__soy428 = function() {
      soy.$$getDelegateFn(soy.$$getDelTemplateId('ClayDropdownBase.Content.idom'), contentRenderer, false)({_handleItemClick: _handleItemClick, contentRenderer: contentRenderer, items: items, itemsIconAlignment: itemsIconAlignment, spritemap: spritemap}, opt_ijData);
    };
    var captionContent__soy437 = function() {
      if (caption) {
        incrementalDom.elementOpenStart('div');
            incrementalDom.attr('class', 'dropdown-caption');
        incrementalDom.elementOpenEnd();
        soyIdom.print(caption);
        incrementalDom.elementClose('div');
      }
    };
    if (button) {
      incrementalDom.elementOpen('form');
      incrementalDom.elementOpenStart('div');
          incrementalDom.attr('class', 'inline-scroller');
      incrementalDom.elementOpenEnd();
      listItemsContent__soy428();
      incrementalDom.elementClose('div');
      captionContent__soy437();
      incrementalDom.elementOpenStart('div');
          incrementalDom.attr('class', 'dropdown-section');
      incrementalDom.elementOpenEnd();
      if ((button.href != null)) {
        $templateAlias4({buttonStyle: button.buttonStyle, elementClasses: 'btn-block', events: {click: _handleButtonClick}, href: button.href, label: button.label, ref: 'dropdownButton'}, opt_ijData);
      } else {
        var $tmp$$1 = button.type;
        $templateAlias1({block: true, events: {click: _handleButtonClick}, label: button.label, ref: 'dropdownButton', style: button.style, type: $tmp$$1 != null ? $tmp$$1 : 'button'}, opt_ijData);
      }
      incrementalDom.elementClose('div');
      incrementalDom.elementClose('form');
    } else {
      listItemsContent__soy428();
      captionContent__soy437();
    }
    incrementalDom.elementClose('div');
  };
  var param480 = function() {
    dropdownMenu__soy475();
  };
  $templateAlias2({content: param480, portalElement: '#' + portalElementId, ref: 'portal'}, opt_ijData);
};
exports.sections = $sections;
/**
 * @typedef {{
 *  items: !Array<?>,
 *  _handleButtonClick: (*|null|undefined),
 *  _handleItemClick: (*|null|undefined),
 *  _handleSearch: (*|null|undefined),
 *  button: (?|undefined),
 *  caption: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  contentRenderer: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  expanded: (boolean|null|undefined),
 *  helpText: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  itemsIconAlignment: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  portalElementId: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  searchable: (boolean|null|undefined),
 *  spritemap: (!goog.soy.data.SanitizedContent|null|string|undefined),
 * }}
 */
$sections.Params;
if (goog.DEBUG) {
  $sections.soyTemplateName = 'ClayDropdownBase.sections';
}


/**
 * @param {$trigger.Params} opt_data
 * @param {Object<string, *>=} opt_ijData
 * @param {Object<string, *>=} opt_ijData_deprecated
 * @return {void}
 * @suppress {checkTypes|uselessCode}
 */
var $trigger = function(opt_data, opt_ijData, opt_ijData_deprecated) {
  opt_ijData = opt_ijData_deprecated || opt_ijData;
  /** @type {!goog.soy.data.SanitizedContent|function()|string} */
  var label = soy.asserts.assertType(goog.isFunction(opt_data.label) || (goog.isString(opt_data.label) || opt_data.label instanceof goog.soy.data.SanitizedContent), 'label', opt_data.label, '!goog.soy.data.SanitizedContent|function()|string');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var classes = soy.asserts.assertType(opt_data.classes == null || (goog.isString(opt_data.classes) || opt_data.classes instanceof goog.soy.data.SanitizedContent), 'classes', opt_data.classes, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {boolean|null|undefined} */
  var disabled = soy.asserts.assertType(opt_data.disabled == null || (goog.isBoolean(opt_data.disabled) || opt_data.disabled === 1 || opt_data.disabled === 0), 'disabled', opt_data.disabled, 'boolean|null|undefined');
  /** @type {boolean|null|undefined} */
  var expanded = soy.asserts.assertType(opt_data.expanded == null || (goog.isBoolean(opt_data.expanded) || opt_data.expanded === 1 || opt_data.expanded === 0), 'expanded', opt_data.expanded, 'boolean|null|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var size = soy.asserts.assertType(opt_data.size == null || (goog.isString(opt_data.size) || opt_data.size instanceof goog.soy.data.SanitizedContent), 'size', opt_data.size, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var style = soy.asserts.assertType(opt_data.style == null || (goog.isString(opt_data.style) || opt_data.style instanceof goog.soy.data.SanitizedContent), 'style', opt_data.style, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var title = soy.asserts.assertType(opt_data.title == null || (goog.isString(opt_data.title) || opt_data.title instanceof goog.soy.data.SanitizedContent), 'title', opt_data.title, '!goog.soy.data.SanitizedContent|null|string|undefined');
  var buttonAttributes__soy533 = function() {
    if (expanded) {
      incrementalDom.attr('aria-expanded', 'true');
    } else {
      incrementalDom.attr('aria-expanded', 'false');
    }
    incrementalDom.attr('aria-haspopup', 'true');
    incrementalDom.attr('aria-label', 'toggle');
    incrementalDom.attr('class', 'dropdown-toggle btn' + (classes ? ' ' + classes : '') + (size ? ' btn-' + size : '') + (style ? ' btn-' + style : ' btn-unstyled'));
    if (disabled) {
      incrementalDom.attr('disabled', '');
    } else {
      incrementalDom.attr('data-onclick', 'toggle');
    }
    incrementalDom.attr('ref', 'triggerButton');
    if (title) {
      incrementalDom.attr('title', title);
    }
    incrementalDom.attr('type', 'button');
  };
  incrementalDom.elementOpenStart('button');
      buttonAttributes__soy533();
  incrementalDom.elementOpenEnd();
  soyIdom.print(label);
  incrementalDom.elementClose('button');
};
exports.trigger = $trigger;
/**
 * @typedef {{
 *  label: (!goog.soy.data.SanitizedContent|function()|string),
 *  classes: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  disabled: (boolean|null|undefined),
 *  expanded: (boolean|null|undefined),
 *  size: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  style: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  title: (!goog.soy.data.SanitizedContent|null|string|undefined),
 * }}
 */
$trigger.Params;
if (goog.DEBUG) {
  $trigger.soyTemplateName = 'ClayDropdownBase.trigger';
}


/**
 * @param {__deltemplate__ClayDropdownBase_Content_.Params} opt_data
 * @param {Object<string, *>=} opt_ijData
 * @param {Object<string, *>=} opt_ijData_deprecated
 * @return {void}
 * @suppress {checkTypes|uselessCode}
 */
var __deltemplate__ClayDropdownBase_Content_ = function(opt_data, opt_ijData, opt_ijData_deprecated) {
  opt_ijData = opt_ijData_deprecated || opt_ijData;
  opt_data = opt_data || {};
  /** @type {*|null|undefined} */
  var _handleItemClick = opt_data._handleItemClick;
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var contentRenderer = soy.asserts.assertType(opt_data.contentRenderer == null || (goog.isString(opt_data.contentRenderer) || opt_data.contentRenderer instanceof goog.soy.data.SanitizedContent), 'contentRenderer', opt_data.contentRenderer, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {!Array<?>|null|undefined} */
  var items = soy.asserts.assertType(opt_data.items == null || goog.isArray(opt_data.items), 'items', opt_data.items, '!Array<?>|null|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var itemsIconAlignment = soy.asserts.assertType(opt_data.itemsIconAlignment == null || (goog.isString(opt_data.itemsIconAlignment) || opt_data.itemsIconAlignment instanceof goog.soy.data.SanitizedContent), 'itemsIconAlignment', opt_data.itemsIconAlignment, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var spritemap = soy.asserts.assertType(opt_data.spritemap == null || (goog.isString(opt_data.spritemap) || opt_data.spritemap instanceof goog.soy.data.SanitizedContent), 'spritemap', opt_data.spritemap, '!goog.soy.data.SanitizedContent|null|string|undefined');
  if (items) {
    incrementalDom.elementOpenStart('ul');
        incrementalDom.attr('class', 'list-unstyled');
    incrementalDom.elementOpenEnd();
    $items({_handleItemClick: _handleItemClick, items: items, itemsIconAlignment: itemsIconAlignment, spritemap: spritemap}, opt_ijData);
    incrementalDom.elementClose('ul');
  }
};
exports.__deltemplate__ClayDropdownBase_Content_ = __deltemplate__ClayDropdownBase_Content_;
/**
 * @typedef {{
 *  _handleItemClick: (*|null|undefined),
 *  contentRenderer: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  items: (!Array<?>|null|undefined),
 *  itemsIconAlignment: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  spritemap: (!goog.soy.data.SanitizedContent|null|string|undefined),
 * }}
 */
__deltemplate__ClayDropdownBase_Content_.Params;
if (goog.DEBUG) {
  __deltemplate__ClayDropdownBase_Content_.soyTemplateName = 'ClayDropdownBase.__deltemplate__ClayDropdownBase_Content_';
}
soy.$$registerDelegateFn(soy.$$getDelTemplateId('ClayDropdownBase.Content.idom'), '', 0, __deltemplate__ClayDropdownBase_Content_);

exports.render.params = ["items","label","_handleButtonClick","_handleItemClick","_handleSearch","button","caption","contentRenderer","disabled","elementClasses","expanded","helpText","id","itemsIconAlignment","portalElementId","searchable","spritemap","style","triggerClasses","triggerSize","triggerTitle"];
exports.render.types = {"items":"list<?>","label":"html|string","_handleButtonClick":"any","_handleItemClick":"any","_handleSearch":"any","button":"?","caption":"string","contentRenderer":"string","disabled":"bool","elementClasses":"string","expanded":"bool","helpText":"string","id":"string","itemsIconAlignment":"string","portalElementId":"string","searchable":"bool","spritemap":"string","style":"string","triggerClasses":"string","triggerSize":"string","triggerTitle":"string"};
exports.items.params = ["items","_handleItemClick","contentRenderer","itemsIconAlignment","maxItems","spritemap"];
exports.items.types = {"items":"list<?>","_handleItemClick":"any","contentRenderer":"string","itemsIconAlignment":"string","maxItems":"int","spritemap":"string"};
exports.search.params = ["spritemap","_handleSearch"];
exports.search.types = {"spritemap":"string","_handleSearch":"any"};
exports.sections.params = ["items","_handleButtonClick","_handleItemClick","_handleSearch","button","caption","contentRenderer","expanded","helpText","itemsIconAlignment","portalElementId","searchable","spritemap"];
exports.sections.types = {"items":"list<?>","_handleButtonClick":"any","_handleItemClick":"any","_handleSearch":"any","button":"?","caption":"string","contentRenderer":"string","expanded":"bool","helpText":"string","itemsIconAlignment":"string","portalElementId":"string","searchable":"bool","spritemap":"string"};
exports.trigger.params = ["label","classes","disabled","expanded","size","style","title"];
exports.trigger.types = {"label":"html|string","classes":"string","disabled":"bool","expanded":"bool","size":"string","style":"string","title":"string"};
templates = exports;
return exports;

});

class ClayDropdownBase extends Component {}
Soy.register(ClayDropdownBase, templates);
export { ClayDropdownBase, templates };
export default templates;
/* jshint ignore:end */
